import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { apiRequest } from '../ApiService/Allapi';
import Swal from "sweetalert2";

function BlogDetail() {
 

  return (
    <></>
  );
}

export default BlogDetail;
